import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchProduct, fetchProductPromo } from "./productsAPI";

const initialState = {
  status: "idle",
  status_addon: "idle",
  error: {
    msg: "",
    status: false,
  },
  activeGID: 0,
  current: {},
};

export const getProduct = createAsyncThunk(
  "products/getFromPID",
  async (pid) => {
    const response = await fetchProduct(pid);
    return response;
  }
);

export const getProductPromo = createAsyncThunk(
  "products/getProductPromo",
  async (data) => {
    const response = await fetchProductPromo(data);
    return response;
  }
);

export const productsSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    removeCurrentProducts: () => {
      return initialState;
    },
    setCurrentGID: (state, action) => {
      state.current_gid = action.payload;
    },
    resetError: (state) => {
      state.error = {
        msg: "",
        status: false,
      };
    },
    replaceCurrentProducts: (state, action) => {
      state.current = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProduct.pending, (state) => {
        state.error = { msg: "", status: false };
        state.status = "loading";
      })
      .addCase(getProduct.fulfilled, (state, action) => {
        const { products } = action.payload;

        if (!products) {
          state.error = {
            msg: "Produk tidak ditemukan, coba lagi!",
            status: true,
          };
          return;
        }

        state.status = "idle";
        state.activeGID = products?.product[0].gid;
        state.current = products?.product[0];
      })
      .addCase(getProduct.rejected, (state) => {
        state.error = { msg: "Internal Server Error", status: true };
      })
      .addCase(getProductPromo.pending, (state) => {
        state.error = { msg: "", status: false };
        state.status = "loading";
      })
      .addCase(getProductPromo.fulfilled, (state, action) => {
        const { products } = action.payload;

        if (!products) {
          state.error = {
            msg: "Produk tidak ditemukan, coba lagi!",
            status: true,
          };
          return;
        }

        state.status = "idle";
        state.activeGID = products?.product[0].gid;
        state.current = products?.product[0];
      })
      .addCase(getProductPromo.rejected, (state) => {
        state.error = { msg: "Internal Server Error", status: true };
      });
  },
});

// Selector
export const selectProductByGID = (gid) => (state) =>
  state.products.datas.find((v) => v.gid === gid);
export const selectProductByPID = (pid) => (state) =>
  state.products.datas.find((v) => v.pid === pid);
export const selectProduct = (state) => state.products;

export const {
  setProductsByCurrentGID,
  removeCurrentProducts,
  setCurrentGID,
  resetError,
  replaceCurrentProducts,
} = productsSlice.actions;
export default productsSlice.reducer;
